import {
  Box, BoxProps, Typography
} from '@mui/material'
import React from 'react'

interface Props extends BoxProps {
  step?: string
  label: string
}

const TimelineFormStep: ReactFC<Props> = ({ children, step, label, sx, ...restParams }) => {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        ...sx
      }}
      {...restParams}
    >
      <Box
        sx={{
          display: 'flex', alignItems: 'center'
        }}
      >
        <Box
          sx={{
            minWidth: '1.6rem',
            minHeight: '1.6rem',
            maxWidth: '1.6rem',
            maxHeight: '1.6rem',
            borderRadius: '50%',
            color: 'white',
            backgroundColor: '#9e9e9e',
            textAlign: 'center',
            fontSize: '14px',
            lineHeight: '1.6rem'
          }}
        >
          {step}
        </Box>
        <Typography
          sx={{
            fontWeight: '500', marginLeft: '.5rem'
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          margin: '.8rem 0 0 .8rem',
          width: '100%'
        }}
      >
        <Box
          sx={{
            paddingLeft: '28px',
            borderLeft: '1px solid #9e9e9e',
            marginBottom: '.25rem'
          }}
        />
        <Box
          sx={{
            width: '100%', paddingBottom: '2rem'
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}
export default TimelineFormStep
